import { FormInput } from "./form-components/form-input.components";
import { useFieldArray, type UseFormReturn } from "react-hook-form";
import { FormLabel } from "./ui/form";
import { Button } from "./ui/button";
import DeleteIcon from "../assets/svgs/common/delete.svg";
import StarIcon from "../assets/svgs/common/star.svg";
import AddIcon from "../assets/svgs/common/add.svg";
import type { IzSampleFormAdmin } from "../z/admin/sample-form.admin.z";

type LinksProps = {
	form: UseFormReturn<IzSampleFormAdmin>; // Use the specific form type
	label?: string;
	required?: boolean;
};

const LinkOfCreatorComponent = ({
	form,
	label,

	required,
}: LinksProps) => {
	const { fields, append, remove } = useFieldArray({
		control: form.control,
		name: "referenceCreators",
	});
	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>

	return (
		<div className="flex flex-col gap-2 w-full">
			{fields.length > 0 && (
				<div className="flex items-center gap-4 w-full">
					<FormLabel className="flex flex-1 items-center gap-1 mr-20 font-semibold">
						{label} {required && <StarIcon />}
					</FormLabel>
				</div>
			)}

			<div className="flex flex-col gap-4 w-full">
				{fields.map((item, index) => (
					<div
						key={item.id}
						className="relative flex items-center gap-4 w-full"
					>
						<FormInput
							form={form}
							name={`referenceCreators.${index}.url`}
							placeholder="Add link of a creator here"
							required={false}
							type="url"
						/>
						<Button
							type="button"
							onClick={() => remove(index)}
							className="bg-transparent mt-2 py-4 border border-border rounded-xl w-fit h-full"
						>
							<DeleteIcon />
						</Button>
					</div>
				))}
				<div className="flex justify-end items-center w-full">
					<div className="">
						<Button
							type="button"
							onClick={() =>
								append({
									url: "" as string,
								})
							}
							className="flex items-center gap-1 bg-tertiarybuttonbg px-7 py-7 border border-border font-semibold self-end"
						>
							<AddIcon />
							{fields.length === 0 ? "Add link" : "Add another link"}
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LinkOfCreatorComponent;
